import { render, staticRenderFns } from "./NewPhysicianModal.vue?vue&type=template&id=1abff13d&scoped=true&"
import script from "./NewPhysicianModal.vue?vue&type=script&lang=js&"
export * from "./NewPhysicianModal.vue?vue&type=script&lang=js&"
import style0 from "./NewPhysicianModal.vue?vue&type=style&index=0&id=1abff13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abff13d",
  null
  
)

component.options.__file = "NewPhysicianModal.vue"
export default component.exports